"use strict";
//https://www.figma.com/file/l62sFQ3ix9Wc4aV7DF8XHb/Developer-Skillzet-v2.0?node-id=38%3A4557
// LAST SYNC: 03.03.22
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
exports.colors = {
    white: '#ffffff',
    black: '#000000',
    // PRIMARY
    primary: {
        Main: '#4890e8',
        Dark: '#3264A2',
        Light: '#6CA6EC',
        ContrastText: '#FFFFFF',
        Background: '#F0F6FD',
        Border: '#A3C7F3',
    },
    // PURPLE (SECONDARY)
    secondary: {
        Main: '#6E7BE8',
        Dark: '#4D65A2',
        Light: '#8B95EC',
        ContrastText: '#FFFFFF',
        Background: '#E8EAFB',
        Border: '#B6BDF3',
    },
    // BLUE (INFO)
    info: {
        Main: '#4890E8',
        Dark: '#3264A2',
        Light: '#6CA6EC',
        ContrastText: '#FFFFFF',
        DarkText: '#2196f3',
        LightBg: '#EDF4FD',
    },
    // RED (ERROR)
    error: {
        Main: '#dd6952',
        Dark: '#9a4939',
        Light: '#e38774',
        ContrastText: '#FFFFFF',
        DarkText: '#663D00',
        LightBg: '#FCF0EE',
    },
    // ORANGE (WARNING)
    warning: {
        Main: '#F59B2C',
        Dark: '#AB6C1E',
        Light: '#F7AF56',
        ContrastText: '#000000DE',
        DarkText: '#ff9800',
        LightBg: '#FEF5EA',
    },
    // GREEN (SUCCESS)
    success: {
        Main: '#7db534',
        Dark: '#577e24',
        Light: '#97c35c',
        ContrastText: '#FFFFFF',
        DarkText: '#1E4620',
        LightBg: '#F2F8EB',
    },
    // GREY
    grey: {
        25: '#f7f7f8',
        50: '#fafafa',
        100: '#f5f5f5',
        200: '#eeeeee',
        300: '#e0e0e0',
        400: '#bdbdbd',
        500: '#717B8F',
        600: '#9e9e9e',
        700: '#616161',
        800: '#424242',
        900: '#212121',
        A100: '#d5d5d5',
        A200: '#aaaaaa',
        A400: '#616161',
        A700: '#303030',
    },
    text: {
        Primary: '#2E323A',
        Secondary: '#717B8F',
        Disabled: '#00000042', // Black with 26% Opacity
    },
    other: {
        Border: '#C4C4C4',
        Divider: '#E0E0E0',
        Backdrop: '#808080',
        Snackbar: '#323232',
        ActiveRating: '#FFB400',
        White: '#ffffff',
        Black: '#000000',
        DisabledBackground: '#0000001F', // Black with 12% Opacity
    },
};
//# sourceMappingURL=colors.js.map